import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';
import {
  PRODUCT_FEDERATION,
  PRODUCT_POST_MATCH,
  orgCanAccessFederation,
  orgCanAccessPostMatch,
  resolveActiveProduct,
  setStoredProduct,
} from '../utils/productWorkspace';
import { track, PRODUCT_DROPDOWN } from '../utils/analytics';

/**
 * Restrained Post-Match | Federation toggle.
 * Only renders when the org is entitled to Federation.
 */
export default function ProductSwitcher({ onNavigate, className = '' }) {
  const { org } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  if (!orgCanAccessFederation(org) || !orgCanAccessPostMatch(org)) return null;

  const active = resolveActiveProduct(org, location.pathname);

  const switchTo = (product) => {
    setStoredProduct(product);
    track(PRODUCT_DROPDOWN, { product, destination: product === PRODUCT_FEDERATION ? 'federation' : 'post_match' });
    const to = product === PRODUCT_FEDERATION ? '/federation/dashboard' : '/dashboard';
    navigate(to);
    if (typeof onNavigate === 'function') onNavigate();
  };

  const btnBase =
    'px-3 py-1.5 text-sm font-medium rounded transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-navy-900';

  return (
    <div
      className={`inline-flex items-center gap-0.5 rounded border border-navy-700 p-0.5 ${className}`}
      role="group"
      aria-label="Product workspace"
    >
      <button
        type="button"
        onClick={() => switchTo(PRODUCT_POST_MATCH)}
        aria-pressed={active === PRODUCT_POST_MATCH}
        className={`${btnBase} ${
          active === PRODUCT_POST_MATCH
            ? 'bg-navy-700 text-white'
            : 'text-white opacity-80 hover:opacity-100 hover:bg-navy-800'
        }`}
      >
        Post-Match
      </button>
      <button
        type="button"
        onClick={() => switchTo(PRODUCT_FEDERATION)}
        aria-pressed={active === PRODUCT_FEDERATION}
        className={`${btnBase} ${
          active === PRODUCT_FEDERATION
            ? 'bg-navy-700 text-white'
            : 'text-white opacity-80 hover:opacity-100 hover:bg-navy-800'
        }`}
      >
        Federation
      </button>
    </div>
  );
}
